import reasonIcons from './index'
import { NotifyPracticeReasons } from 'consts/giConsts'

/**
 * Returns the icon for a Needs Attention reason, falling back to the Other icon.
 *
 * Call sites do `React.createElement(reasonIcons[reason])`, and an unknown reason makes that
 * throw rather than render nothing — which takes the whole surrounding view down. The reason
 * can come from a patient tag, a notification payload, or an open-ended OpenSearch aggregation,
 * so it is not guaranteed to be one this build knows about.
 */
const resolveReasonIcon = reason =>
  (Object.prototype.hasOwnProperty.call(reasonIcons, reason) && reasonIcons[reason]) ||
  reasonIcons[NotifyPracticeReasons.Other]

export default resolveReasonIcon
